/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_ComplyInputs */

const en_svtag_comply = /** @type {(inputs: Svtag_ComplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#COMPLY`)
};

const ar_svtag_comply = /** @type {(inputs: Svtag_ComplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#امتثال`)
};

const bn_svtag_comply = /** @type {(inputs: Svtag_ComplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#COMPLY`)
};

const de_svtag_comply = /** @type {(inputs: Svtag_ComplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#COMPLY`)
};

const es_svtag_comply = /** @type {(inputs: Svtag_ComplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#COMPLY`)
};

const fr_svtag_comply = /** @type {(inputs: Svtag_ComplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#COMPLY`)
};

const pt_svtag_comply = /** @type {(inputs: Svtag_ComplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#COMPLY`)
};

const zh_svtag_comply = /** @type {(inputs: Svtag_ComplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#COMPLY`)
};

const tr_svtag_comply = /** @type {(inputs: Svtag_ComplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#COMPLY`)
};

const ru_svtag_comply = /** @type {(inputs: Svtag_ComplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#COMPLY`)
};

const pl_svtag_comply = /** @type {(inputs: Svtag_ComplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#COMPLY`)
};

/**
* | output |
* | --- |
* | "#COMPLY" |
*
* @param {Svtag_ComplyInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_comply = /** @type {((inputs?: Svtag_ComplyInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_ComplyInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_comply(inputs)
	if (locale === "bn") return bn_svtag_comply(inputs)
	if (locale === "de") return de_svtag_comply(inputs)
	if (locale === "es") return es_svtag_comply(inputs)
	if (locale === "fr") return fr_svtag_comply(inputs)
	if (locale === "pt") return pt_svtag_comply(inputs)
	if (locale === "zh") return zh_svtag_comply(inputs)
	if (locale === "tr") return tr_svtag_comply(inputs)
	if (locale === "ru") return ru_svtag_comply(inputs)
	if (locale === "pl") return pl_svtag_comply(inputs)
	return en_svtag_comply(inputs)
});